import jss from 'jss'
import preset from 'jss-preset-default'
import color from 'color'
import { styles as spectreStyles } from 'spectre.css/dist/spectre.css'

let jssCount = 0

// avoid the font awesome global rules
jss.setup(Object.assign({}, preset(), { generateClassName: (rule, sheet) => `rule-${rule.name || 'noName'}-${jssCount++}` }))

export { jss }

jss.createStyleSheet({ '@global': spectreStyles }).attach()

jss.createStyleSheet({
  '@global': {
    'input, textarea': {
      '&:invalid': {
        boxShadow: 'none'
      }
    }
    , 'input:not([type=checkbox]):not([type=radio]):not([type=submit]):not([type=button])': {
      maxWidth: '20em'
    }
    , 'html, body': {
      color: '#333'
    }
    , 'input[type=checkbox], input[type=radio]': {
      transform: 'scale(2)'
      , margin: '0 0.5em'
    }
    , '.form-input:not(:placeholder-shown):invalid': {
      borderColor: 'rgb(202, 206, 215)'
    }
    , '.form-input:not(:placeholder-shown)[class*=visited]:invalid': { // specificity
      borderColor: 'rgb(232, 86, 0)'
    }
  }
}).attach()

const general = {
  snack: {
    background: '#333'
    , color: 'white'
    , borderRadius: 5
    , boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2)'
    , display: 'inline-block'
    , padding: '0.25em 0.5em'
  }
  , visited: {
    'input&, textarea&': {
      '&:invalid': {
        borderColor: 'rgb(232, 86, 0)'
      }
    }
  }
}

const { classes: generalClasses } = jss.createStyleSheet(general).attach()
export const globalClasses = { general: generalClasses }

document.body.addEventListener('focusout', ({ target }) => target.classList.add(generalClasses.visited))
